import moment, { Moment } from 'moment-timezone';

type BaseOAuthClientDescriptor = {
  name: string;
  accountId: string;
  parameters: OAuthClientParameters;
};

export interface NewOAuthClientDescriptorPayload extends BaseOAuthClientDescriptor {
  expiryDate?: Moment;
  isSPAEnabled: boolean;
}

export interface UpdateOAuthClientDescriptorPayload extends NewOAuthClientDescriptorPayload {
  clientId: string;
}

export interface OAuthClientDescriptorWithoutExpiry extends BaseOAuthClientDescriptor {
  clientId: string;
  isDeleted: boolean;
  isSPAEnabled: boolean;
}

export interface OAuthClientDescriptor extends OAuthClientDescriptorWithoutExpiry {
  expiryDate?: Moment;
}

export interface ServerOAuthClientDescriptor extends OAuthClientDescriptorWithoutExpiry {
  expiryDate?: string;
}

export type ClientCredentialsParameters = {
  secret?: string;
  supportedFlows?: OAuthFlow[];
  allowedWebOrigins?: string[];
};

export interface ImplicitGrantParameters extends ClientCredentialsParameters {
  redirectUris: string[];
}

export type OAuthClientParameters = ClientCredentialsParameters | ImplicitGrantParameters;

export type OAuthFlow = 'CLIENT_CREDENTIALS';

export function mapClients(clients: ServerOAuthClientDescriptor[]): OAuthClientDescriptor[] {
  return clients.map(convertClientFromServer);
}

function convertClientFromServer(client: ServerOAuthClientDescriptor): OAuthClientDescriptor {
  if (client.expiryDate) {
    return {
      ...client,
      expiryDate: moment.utc(client.expiryDate),
    };
  }
  return client as OAuthClientDescriptor;
}
